import React from 'react';

export const Chip = ({ backgroundColor, textColor = 'black', border, children }) => (
  <div
    style={{
      backgroundColor,
      color: textColor,
      borderRadius: '50px',
      padding: '5px 12px',
      width: 'fit-content',
      height: 'fit-content',
      fontSize: '14px',
      border,
    }}
  >
    {children}
  </div>
);
